import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'reducer/store';

const menuIsOpen = createSlice({
  name: 'menuIsOpen',
  initialState: false,
  reducers: {
    setMenuIsOpen: (state, action: PayloadAction<boolean>) => action.payload,
  },
});
// 取值 get
export const getMenuIsOpenReducer = (state: RootState) =>
  state.menuDropbackReducer;
// set
export const menuIsOpenAction = menuIsOpen.actions;
const menuIsOpenReducer = menuIsOpen.reducer;
export default menuIsOpenReducer;
